import Slide1 from '../assets/img/carousel/slide1.jpg';
import Slide4 from '../assets/img/carousel/slide4.jpg';

// import AboutMeImg from '../assets/img/me/person_4-min'

/** Main Carousel Data */
export const mainCarouselData = [
  {
    id: 1,
    title: 'Sandra Vera',
    desc: 'Misión de asesorar, orientar y brindar apoyo integral en todas las facetas del ámbito inmobiliario',
    img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1689975597/Projects/unne/img/hero/tramite2.jpg',
  },
  {
    id: 2,
    title: 'Simplifica tus trámites legales con nuestros abogados inmobiliarios',
    desc: ' Consulta por tu asesoría gratuita',
    img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1690837248/Projects/unne/img/Eres%20corredor/ERES_CORREDOR___SERVICIOS_LEGALES_rhfldh.webp',
  },
  {
    id: 3,
    title: 'Haz que tus ahorros crezcan un 15%',
    desc: 'con inversión remate seguro',
    img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1689974575/Projects/unne/img/hero/remate3.jpg',
  },
  {
    id: 4,
    title: '¡Sácale provecho a tu propiedad!',
    desc: 'Financiamos, Remodelamos y Vendemos',
    img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1710428421/Projects/unne/img/Paginas%20web/fondo4_mnfey4.webp',
  },
];
